import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Validator",
description: "Learn how Freon defines and enforces validation rules to ensure model consistency, including simple value checks, list rules, identifier validation, type checks, and custom error messages.",
tags: [ "validation", "validator", "rules", "constraints", "type checking", "error messages", "Freon", "DSL development", "metamodel"] ,
modifiedTime: "2025-11-07T19:08:45.524Z",
publishedTime: "2025-11-07T17:20:18.625Z"
    }
  };
};